export default {
    header: "404 Page Not Found",
    view: "viewNotFound"
  };  